import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseCommonBanner.module.scss'

const cx = className.bind(style)

type Props = {
  thumbnailUrl: string
  outLinkUrl: string
  backgroundColor: string
  bannerAlt: string
}

const MyhouseCommonBanner: React.FC<Props> = ({ thumbnailUrl = '', outLinkUrl = '#', backgroundColor, bannerAlt = '' }: Props) => {
  return (
    <div className={cx('article')}>
      <a href={outLinkUrl} className={cx('link_banner')} style={{ backgroundColor }} target="_blank" rel="noopener noreferrer">
        <img className={cx('banner_image')} src={thumbnailUrl} alt={bannerAlt} />
      </a>
    </div>
  )
}

export default MyhouseCommonBanner
